// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_ADD_MODERATOR = "Pridaj moder\u00e1torku";
export const FORUM_TOPIC_MODERATOR_LEFT_ON_when = "zmazan\u00e1 %(when)s";
